const BASE_URL = 'http://34.93.4.75/lvp';

export const apiService = {
  // Get all dashboard data
  getDashboardData: async () => {
    try {
      console.log('Fetching data from:', `${BASE_URL}/dashboard`);
      const response = await fetch(`${BASE_URL}/dashboard`, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      console.log('Response Status:', response.status);
      console.log('Response Headers:', response.headers);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error Response:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }
      
      const data = await response.json();
      console.log('Received data:', data);
      return data.data;
    } catch (error) {
      console.error('Detailed error:', error);
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        console.error('Network error - possible CORS or connectivity issue');
      }
      throw error;
    }
  },

  // Get PR details by PR number
  getPRDetails: async (prNumber) => {
    try {
      console.log('Fetching PR details for:', prNumber);
      const response = await fetch(`${BASE_URL}/pr-details/${prNumber}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error Response:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }
      
      const data = await response.json();
      console.log('Received PR details:', data);
      return data.data;
    } catch (error) {
      console.error('Detailed error:', error);
      throw error;
    }
  },

  // Get validation details by PR number
  getValidationDetails: async (prNumber) => {
    try {
      console.log('Fetching validation details for:', prNumber);
      const response = await fetch(`${BASE_URL}/validation/${prNumber}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error Response:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }
      
      const data = await response.json();
      console.log('Received validation details:', data);
      return data;
    } catch (error) {
      console.error('Detailed error:', error);
      throw error;
    }
  },

  // Download attachment
  downloadAttachment: async (prNumber, fileName) => {
    try {
      console.log('Downloading attachment:', fileName, 'for PR:', prNumber);
      const url = `${BASE_URL}/attachments/${prNumber}/${encodeURIComponent(fileName)}`;
      console.log('Download URL:', url);
      
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
      });
      
      console.log('Download response status:', response.status);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Download error response:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }
      
      const blob = await response.blob();
      console.log('Blob created:', blob.size, 'bytes');
      return blob;
    } catch (error) {
      console.error('Download error:', error);
      throw error;
    }
  },

  // Submit PR action (approve/deny)
  submitPRAction: async (prNumber, action, comment) => {
    try {
      const response = await fetch(`${BASE_URL}/pr/${prNumber}/action`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ action, comment }),
        signal: AbortSignal.timeout(300000), // 5 min timeout
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || `HTTP ${response.status}`);
      }

      return data;
    } catch (error) {
      console.error('PR action error:', error);
      throw error;
    }
  },
};

export default apiService;
